/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default (value, ...args) =>
{
  return (value instanceof Function) ? value(...args) : value;
}
